function readPrice(value, name) {
  const normalized = String(value ?? "").trim();
  if (!/^\d+(\.\d{1,2})?$/.test(normalized) || !Number.isFinite(Number(normalized)) || Number(normalized) <= 0) {
    throw new Error(`${name} must be configured as a positive amount with at most two decimal places`);
  }
  return Number(normalized);
}

// CRA replaces these explicit process.env references at build time.
export const NEW_COURSE_PRICE = readPrice(process.env.REACT_APP_COURSE_PRICE, "REACT_APP_COURSE_PRICE");
export const LEGACY_COURSE_PRICE = readPrice(process.env.REACT_APP_LEGACY_COURSE_PRICE, "REACT_APP_LEGACY_COURSE_PRICE");
export const LEGACY_INVOICE_PRICE = readPrice(process.env.REACT_APP_LEGACY_INVOICE_PRICE, "REACT_APP_LEGACY_INVOICE_PRICE");
export const COUPON_BASE_PRICE = readPrice(process.env.REACT_APP_COUPON_BASE_PRICE, "REACT_APP_COUPON_BASE_PRICE");
export const COURSE_PRICE_LABEL = NEW_COURSE_PRICE.toFixed(2).replace(/\.00$/, "");

export function formatCoursePriceText(text) {
  return text.replaceAll("{{COURSE_PRICE}}", COURSE_PRICE_LABEL);
}

export function getCoursePrice(user) {
  const rawPrice = user?.amount;
  const savedPrice = Number(rawPrice);
  return rawPrice != null && String(rawPrice).trim() !== "" && Number.isFinite(savedPrice) && savedPrice >= 0
    ? savedPrice
    : LEGACY_COURSE_PRICE;
}

export function getDisplayedCoursePrice(user, course = "first") {
  if (user?.totalAmount != null && Number.isFinite(Number(user.totalAmount))) {
    return Number(user.totalAmount).toFixed(2);
  }
  // Legacy API/session fallback; the server supplies the actual coupon total.
  return (user?.[`couponcode_${course}`] ? COUPON_BASE_PRICE : getCoursePrice(user)).toFixed(2);
}

export function getInvoiceAmount(student) {
  const amount = String(student?.amount ?? "").replace(/^\$/, "");
  return amount !== "" && Number.isFinite(Number(amount))
    ? amount
    : String(LEGACY_INVOICE_PRICE);
}
